const TABS = {
  aula: 'aula',
  cronograma: 'cronograma',
  simulados: 'simulados',
};

export default TABS;
